import { useMemo } from 'react'
import { useWindowSize } from 'lib/hooks'
import HeroBanner from '../HeroBanner/HeroBanner'
import { CmsLandingPageComponent } from '../types'

const MAX_MOBILE_WIDTH = 768

interface HeroBannerBreakpointHOCProps {
  components?: CmsLandingPageComponent[]
  slot?: number
}

const HeroBannerBreakpointHOC = ({
  components = [],
  slot = 1,
}: HeroBannerBreakpointHOCProps) => {
  const { width } = useWindowSize(200)

  const mobileBanners = useMemo(
    () => components?.filter((c) => c.displayBreakpoint === 'Mobile'),
    [components]
  )
  const desktopBanners = useMemo(
    () => components?.filter((c) => c.displayBreakpoint === 'Desktop'),
    [components]
  )

  const props = useMemo(() => {
    // Default to the first component we can find regardless of configured breakpoints
    let [breakpointProps] = components

    // If breakpoint is mobile and we have mobile banners, use the first mobile banner
    if (width && width <= MAX_MOBILE_WIDTH && mobileBanners?.length) {
      const [mobileProps] = mobileBanners
      breakpointProps = mobileProps
    }

    // If breakpoint is desktop and we have desktop banners, use the first desktop banner
    if (width && width > MAX_MOBILE_WIDTH && desktopBanners?.length) {
      const [desktopProps] = desktopBanners
      breakpointProps = desktopProps
    }

    return breakpointProps
  }, [components, width])

  // If we don't have any props, don't render anything
  if (!props) {
    return null
  }

  return <HeroBanner slot={slot} {...props} />
}

export default HeroBannerBreakpointHOC
